import { ApplicantInformation, RawApplicantInformation } from './@types/ApplicantInformation';

function capitalizeWords(inputString: string): string {
  // Split the input string into an array of words
  const words = inputString.split(' ');

  const exceptionsToKeepUppercase = ['LLC', 'II', 'III'];

  // Capitalize the first letter of each word
  const capitalizedWords = words.map((word) => {
    // Handle empty strings, spaces between words, and exceptions
    if (word.length === 0 || exceptionsToKeepUppercase.includes(word)) {
      return word;
    }
    const firstLetter = word.charAt(0).toUpperCase();
    const restOfWord = word.slice(1).toLowerCase();
    return firstLetter + restOfWord;
  });

  // Join the capitalized words back into a string
  const capitalizedString = capitalizedWords.join(' ');

  return capitalizedString;
}

function formatValues(input: RawApplicantInformation): ApplicantInformation {
  return {
    applicantId: input.applicant_id,
    companyName: capitalizeWords(input.company_name),
    dotNumber: input.dot_number,
    email: input.email.toLowerCase(),
    firstName: capitalizeWords(input.first_name),
    lastName: capitalizeWords(input.last_name),
    mcNumber: input.mc_number,
    telephone: input.telephone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3'),
  };
}

/**
 * Converts string from snake case to lower camel
 * case.
 */
function snakeToCamelCase(s: string): string {
  return s.replace(/([-_][a-z])/gi, ($1) => {
    return $1.toUpperCase().replace('-', '').replace('_', '');
  });
}

export { capitalizeWords, formatValues, snakeToCamelCase };
